import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/matter.png'


const _withScopeId = n => (_pushScopeId("data-v-ed2790f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-content" }
const _hoisted_2 = { class: "detail-status hea-column" }
const _hoisted_3 = {
  key: 0,
  class: "err-div"
}
const _hoisted_4 = {
  key: 1,
  class: "tip-div"
}
const _hoisted_5 = { class: "customer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-title" }, "客户信息", -1))
const _hoisted_7 = { class: "customer-warp" }
const _hoisted_8 = { class: "form-list van-hairline--top" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "性别", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "保单编号", -1))
const _hoisted_12 = { class: "warranty" }
const _hoisted_13 = {
  key: 0,
  class: "policy-numbers"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收起", -1))
const _hoisted_16 = {
  key: 0,
  class: "physical"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "physical-title" }, "预约信息", -1))
const _hoisted_18 = { class: "form-list physical-info van-hairline--top" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "体检机构", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "体检地址", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "预约时间", -1))
const _hoisted_22 = { class: "physical" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "physical-title" }, "体检信息", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "van-hairline--top xian" }, null, -1))
const _hoisted_25 = { class: "physical-warp" }
const _hoisted_26 = { class: "projec-type" }
const _hoisted_27 = {
  key: 0,
  class: "footer"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "btn-list"
}
const _hoisted_30 = { class: "overlay-wrapper-block" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay-text" }, "是否取消此次体检预约？", -1))
const _hoisted_32 = { class: "btn-list overlay-btn" }
const _hoisted_33 = { class: "overlay-wrapper-block" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay-text" }, "成功修改预约时间", -1))
const _hoisted_35 = { class: "overlay-btn" }

import { computed, onMounted, reactive, ref } from 'vue';
    import { Toast } from 'vant';
    import tabbar from "src/components/common/tabbar";
    import dayjs from 'dayjs';
    import { PhysicalService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import UpageList from 'src/components/common/page-list';
    import PageBack from 'src/components/common/page-back';
    import uScheduling from 'src/components/common/scheduling';
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { setAccessToken, setRefreshToken } = useToken();
    const router = useRouter();
    const route = useRoute();
    /// 体检任务状态 (12:问卷未进行 ,1:待预约 ,2:已预约 6:已体检 ,13:已完成 ,14:已无效,15:已结算)

    let $pageList = ref(null)
    let key = ref("")
    let showOverlay = ref(false)
    let showChangeOverlay = ref(false)
    let showDate = ref(false)
    const activeNames = ref([]);

    let detailInfo = ref({
        id: null,
        statusStr: "",
        memberName:"",
        invalidateTime:"",
        memberSexStr: "",
        policyNumbers: [],
        active: false,
        status: 1,
        physicalInfo:{
            hospitalId:0,
            packageId: 0,
            physicalItems:{},
            hospitalName: "",
            fullAddress: "",
            physicalDate: ""
        }
    })

    onMounted(()=>
    {
        if(route.query.id)
        {
            getphysicalDetail(route.query.id)
        }
    })

    /**
     * 获取体检任务 
     */
    let getphysicalDetail = async (id)=>
    {
        try {
            let { content: res } = await PhysicalService.instance.getphysicalDetail(id);
            if(res.data)
            {
                detailInfo.value = res.data;
            }
        } catch (err) {
            Toast(err);
        }
    }

    let openMap = ()=>
    {
        let href = `http://uri.amap.com/marker?position=${detailInfo.value.physicalInfo.longitude},${detailInfo.value.physicalInfo.latitude}&name=${detailInfo.value.physicalInfo.hospitalName}&coordinate=gaode&callnative=1`;
        window.open(href);
    }

    /**
     * 取消 
     */
    let cancelReserve = async ()=>
    {
        try {
            let { content: res } = await PhysicalService.instance.cancelReserve(detailInfo.value.id);
            Toast("取消成功")
            showOverlay.value = false;
            getphysicalDetail(detailInfo.value.id)
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 搜索 
     */
    let onSearch = (parameter)=>
    {
        $pageList.value.onRefresh()
    }

    /**
     * 搜索 
     */
    let onReserve = (parameter)=>
    {
        router.push({name: "org", query:{id: detailInfo.value.id}});
    }

    /**
     * 搜索 
     */
    let onMatter = (parameter)=>
    {
        router.push({name:"sucess", query:{id: detailInfo.value.id}});
    }

    /**
     * 确认日期 
     */
    let onDateConfirm = async (date)=>
    {
        try
        {
            await PhysicalService.instance.changeReserve({
                id: detailInfo.value.id,
                hospitalId: detailInfo.value.physicalInfo.hospitalId,
                hospitalName: detailInfo.value.physicalInfo.hospitalName,
                physicalDate: date
            })
            getphysicalDetail(detailInfo.value.id);
            showChangeOverlay.value = true;
        }
        catch(err)
        {
            Toast(err)
        }
    }
    

    

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageBack)),
    _createElementVNode("div", {
      class: _normalizeClass(["detail-warp", {p40:_unref(detailInfo).status == 1 || _unref(detailInfo).status == 2}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).statusStr), 1),
        (_unref(detailInfo).msg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(detailInfo).msg), 1))
          : _createCommentVNode("", true),
        (_unref(detailInfo).status == 12 && !_unref(detailInfo).msg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 体检项目可能会因问卷加项、健康资料变动等有所调整 "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _hoisted_9,
              _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).memberName), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).memberSexStr), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["warranty-warp right", {auto:_unref(detailInfo).active}])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailInfo).policyNumbers, (d) => {
                    return (_openBlock(), _createElementBlock("span", { key: d }, _toDisplayString(d), 1))
                  }), 128)),
                  (_unref(detailInfo).policyNumbers.length>2 && !_unref(detailInfo).active)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "..."))
                    : _createCommentVNode("", true)
                ], 2),
                (_unref(detailInfo).policyNumbers.length>2)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "more",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(detailInfo).active = !!!_unref(detailInfo).active), ["stop"]))
                    }, [
                      (!_unref(detailInfo).active)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_14,
                            _createVNode(_component_van_icon, { name: "arrow-down" })
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_15,
                            _createVNode(_component_van_icon, { name: "arrow-up" })
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      (_unref(detailInfo).status == 2 || _unref(detailInfo).status == 6 || _unref(detailInfo).status == 13)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", null, [
                _hoisted_19,
                _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.hospitalName), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_20,
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openMap) && _unref(openMap)(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.fullAddress) + " ", 1),
                  _createVNode(_component_van_icon, {
                    name: "location-o",
                    color: "#D41446"
                  })
                ])
              ]),
              _createElementVNode("li", null, [
                _hoisted_21,
                _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.physicalDate), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          (_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.physicalItems)
            ? (_openBlock(), _createBlock(_component_van_collapse, {
                key: 0,
                border: false,
                modelValue: activeNames.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeNames).value = $event)),
                class: "optional"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(detailInfo).physicalInfo.physicalItems), (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_collapse_item, {
                      border: false,
                      name: index,
                      key: index
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(item), 1)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailInfo).physicalInfo.physicalItems[item], (d) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "project-item-name",
                            key: d
                          }, _toDisplayString(d), 1))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(detailInfo).status ==2 || _unref(detailInfo).status ==6 || _unref(detailInfo).status ==13|| _unref(detailInfo).status ==15)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_0,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onMatter) && _unref(onMatter)(...args))),
            class: "matter-img"
          }))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(detailInfo).status == 1 || _unref(detailInfo).status == 2 || _unref(detailInfo).status == 12)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          (_unref(detailInfo).status == 1 || _unref(detailInfo).status == 12)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn-primary", {'disabled-btn': _unref(detailInfo).status == 12}]),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onReserve) && _unref(onReserve)(...args))),
                disabled: _unref(detailInfo).status == 12
              }, "开始预约", 10, _hoisted_28))
            : _createCommentVNode("", true),
          (_unref(detailInfo).status==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("button", {
                  class: "btn-cancel van-hairline--surround",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showOverlay) //@ts-ignore
 ? showOverlay.value = true : showOverlay=true))
                }, "取消预约"),
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(showDate) //@ts-ignore
 ? showDate.value = true : showDate = true))
                }, "修改预约时间")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, {
      show: _unref(showOverlay),
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_isRef(showOverlay) //@ts-ignore
 ? showOverlay.value = false : showOverlay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                class: "btn-cancel van-hairline--surround",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_isRef(showOverlay) //@ts-ignore
 ? showOverlay.value = false : showOverlay = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(cancelReserve) && _unref(cancelReserve)(...args)))
              }, "确认")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showChangeOverlay),
      onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(showChangeOverlay) //@ts-ignore
 ? showChangeOverlay.value = false : showChangeOverlay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_isRef(showChangeOverlay) //@ts-ignore
 ? showChangeOverlay.value = false : showChangeOverlay = false))
              }, "确认")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(uScheduling), {
      value: _unref(showDate),
      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_isRef(showDate) ? (showDate).value = $event : showDate = $event)),
      onOnDateConfirm: _unref(onDateConfirm),
      userName: _unref(detailInfo).memberName,
      invalidateTime: _unref(detailInfo).invalidateTime,
      hospitalId: _unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.hospitalId,
      taskId: _unref(detailInfo).id
    }, null, 8, ["value", "onOnDateConfirm", "userName", "invalidateTime", "hospitalId", "taskId"])
  ]))
}
}

})